import { motion } from "framer-motion";
import { Heart, Eye, Check } from "lucide-react";

const CYCLES = [
    {
        id: "romantasy",
        icon: Heart,
        cycle: "Ciclo Romantasy",
        cycleBadge: "badge-fantasy",
        book: "Powerless",
        desc: "Primo appuntamento del ciclo romantasy del club.",
        day: 25,
        month: "ott",
    },
    {
        id: "comics",
        icon: Eye,
        cycle: "Ciclo Comics",
        cycleBadge: "badge-fantascienza",
        book: "Watchmen",
        desc: "Primo appuntamento del ciclo comics del club.",
        day: 29,
        month: "nov",
    },
];

export default function SpinOff() {
    return (
        <div data-testid="spinoff-list">
            <div className="flex flex-col gap-5">
                {CYCLES.map((c, i) => (
                    <motion.div
                        key={c.id}
                        className="parchment-card p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5"
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: i * 0.08 }}
                        data-testid={`spinoff-row-${c.id}`}
                    >
                        <div className="flex items-center gap-4 sm:gap-5 sm:flex-1">
                            <div className="date-box" data-testid={`spinoff-date-${c.id}`}>
                                <span className="day">{c.day}</span>
                                <span className="month">{c.month}</span>
                            </div>
                            <span className="shrink-0 w-11 h-11 rounded-full border border-[#b08d57]/60 bg-[rgba(176,141,87,0.14)] flex items-center justify-center text-[#7a5a2e]">
                                <c.icon size={20} strokeWidth={1.5} />
                            </span>
                            <span className={`badge ${c.cycleBadge}`}>{c.cycle}</span>
                        </div>
                        <div className="flex-1">
                            <h3 className="f-title text-lg sm:text-xl text-[#3f2a12] leading-snug">{c.book}</h3>
                            <p className="f-body italic text-[#6d5638] mt-1 text-sm sm:text-base">{c.desc}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
            <p className="f-body italic text-[#6d5638] text-center mt-10 text-base" data-testid="spinoff-note">
                I fili laterali del tomo: ogni ciclo a tema apre con il suo primo appuntamento.
            </p>
        </div>
    );
}
